import { connect } from 'react-redux'
import FollowRecommendationsFirstRunCongratsComponent from '../components/follow_recommendations_first_run_congrats';

const mapStateToProps = (state) => {
  return {
    user: state.default.user
  }
}

export default connect(mapStateToProps)(FollowRecommendationsFirstRunCongratsComponent);



// WEBPACK FOOTER //
// ./src/containers/follow_recommendations_first_run_congrats_container.js